<template>
  <div>
    <b-card
      header="로그 모니터링"
      style="max-width: 50rem; margin: auto; margin-top: 3vh;"
      class="mb-2"
      align="left"
    >
      <b-form-group>
        <b-row>
          <b-col class="my-1" align="end">
            <b-button-group rounded mandatory>
              <b-button size="sm" @click="perPage = 10"> 10 </b-button>
              <b-button size="sm" @click="perPage = 20"> 20 </b-button>
              <b-button size="sm" @click="perPage = 30"> 30 </b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </b-form-group>

      <b-table
        striped
        outlined
        responsive="sm"
        hover
        select-mode="multi"
        id="table"
        ref="selecttableTable"
        :items="results"
        :fields="fields"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #table-colgroup="scope">
          <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: field.width }"
          />
        </template>
      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        align="center"
      ></b-pagination>

      <Spinner />
    </b-card>
    <Modal />
  </div>
</template>

<script>
import Spinner from "../components/Spinner";
import { init, setSnackBarInfo } from "../js/common_function";

import { DateTime } from "luxon";

export default {
  name: "LogMonitoring",
  components: {
    Spinner,
  },
  data() {
    return {
      selected: [],
      totalRows: 1,
      filter: null,
      filterOn: [],
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          key: "logUser",
          label: "logUser",
          sortable: true,
          // width: "7%",
        },
        {
          key: "userIP",
          label: "userIP",
          sortable: true,
          // width: "75%"
        },
        {
          key: "date",
          // formatter: "formatDateAssigned",
          label: "date",
          sortable: true,
        },
        {
          key: "path",
          label: "경로",
          sortable: true,
        },
        {
          key: "city",
          label: "도시",
          sortable: true,
        },
        {
          key: "subdivision",
          label: "시군구",
          sortable: true,
        },
        {
          key: "latitude",
          label: "위도",
          sortable: true,
        },
        {
          key: "longtitude",
          label: "경도",
          sortable: true,
        },
      ],
      results: [],
      errors: [],
    };
  },
  computed: {
    rows() {
      return this.results.length;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },

  methods: {
    // formatDateAssigned(value) {
    //   const formattedDate = DateTime.fromISO(
    //     value
    //   ).toFormat('LLLdd')
    //   return formattedDate;
    // },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // Fetches posts when the component is created.

    callAllListApi() {
      this.$store.commit("START_SPINNER");
      this.$axios({
        url: this.$config.baseURL + "/getLogList",
        method: "get",
        headers: {
          "token-key": localStorage.getItem("token-key"),
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.results = response.data;
            this.$store.commit("END_SPINNER");
          } else {
            this.$store.commit(
              "SET_SNACKBAR",
              setSnackBarInfo("권한이 없습니다.")
            );
            this.$store.commit("END_SPINNER");
          }
        })
        .catch((error) => {
          this.$store.commit("SET_SNACKBAR", setSnackBarInfo("서버 에러 발생"));

          this.errors.push(error);
          console.log(error);
          this.$store.commit("END_SPINNER");
        });
    },
  },
  async mounted() {
    this.$parent.$parent.$children.map(function (value, key) {
      if (value.$options._componentTag === "AppBar") {
        value.navTopBar = false;
      }
    });
    const path = this.$route.fullPath;
    document.body.setAttribute("oncontextmenu", "return true");
    document.body.setAttribute("onselectstart", "return true");
    document.body.setAttribute("ondragstart", "return true");
    init(path).then(() => {
      this.callAllListApi();
      // this.$store.commit('END_SPINNER');
    });
  },
};
</script>
